export const getReportBlockPaginationId = (reportBlockId: string) => {
  return `r-${reportBlockId}-pagination-container`;
};
